export default {
    current_choice: 'Mevcut seçim',
    book_now: 'Şimdi rezervasyon yap',
    minimum_age: 'Yalnızca {age} Yaş Üstü',
    excess_liability: 'Sorumluluk muafiyeti',
    security_deposit: 'Deposito',
    fuel_policy: 'Yakıt Politikası',
    like_for_like: 'Aldığın Gibi Bırak',
    full_to_full: 'Dolu Teslim Al, Dolu Teslim Et',
    miles_per_rental: 'Adil yakıt politikası {mileage} mil',
    km_per_rental: 'Adil yakıt politikası {mileage} km',
    unlimited_mileage: 'Sınırsız kilometre',
    unlimited_mileage_km: 'Sınırsız km',
    non_amendable: 'Değiştirilemez',
    non_refundable: 'İade Yok',
    free_cancellation_until: 'Şu tarihe kadar ücretsiz iptal:',
    cancellation_in_line_with: 'İptal işlemleri',
    tcs: 'Şart ve Koşullar doğrultusundadır',
    free_extras_on_collection: 'Alım noktasında iki ücretsiz ekstra',
    glass_and_tyres_covered: 'Cam ve lastik güvenceli',
    number_of_passengers: 'Yolcu sayısı',
    number_of_bags: 'Çanta sayısı',
    fuel_type: 'Yakıt türü',
    co2: 'Karbondioksit',
    aircon: 'Klima',
    transmission: 'Vites',
    book_type: '{type} rezervasyonu yap',
    debit_card_deposit: 'Depozitolar İçin Banka Kartı Kabul Edildi',
    fast_track_included: 'Hızlı Geçiş Dahil',
}
